export default __webpack_public_path__ + "static/media/fontawesome-webfont.ed629890.svg";